export default [
    {
        name: "reddit",
        icon: "fab fa-reddit-alien",
        url: "https://www.reddit.com",
        hotkey: "r"
    },
    {
        name: "Twitter",
        icon: "fab fa-twitter",
        url: "https://www.twitter.com",
        hotkey: "t"
    },
    {
        name: "gmail",
        icon: "fas fa-envelope",
        url: "https://gmail.com",
        hotkey: "m"
    },
    {
        name: "github",
        icon: "fab fa-github",
        url: "https://github.com/kalenpw",
        hotkey: "g"
    },
    {
        name: "netflix",
        icon: "fas fa-film",
        url: "https://media.kalenpw.com",
        hotkey: "j"
    },
    // {
    //     name: "4chan",
    //     icon: "fas fa-paw",
    //     url: "https://www.4chan.org",
    //     hotkey: "4"
    // },
    {
        name: "youtube",
        icon: "fab fa-youtube",
        url: "https://youtube.com",
        hotkey: "y"
    },
    {
        name: "wiki",
        icon: "fab fa-wikipedia-w",
        url: "https://wiki.kalen.pw",
        hotkey: "w"
    },
    {
        name: "chess",
        icon: "fas fa-chess-knight",
        url: "https://lichess.org",
        hotkey: "c"
    },
]

